import { render, staticRenderFns } from "./GiftPromotionList.vue?vue&type=template&id=9a0eb55c&scoped=true"
import script from "./GiftPromotionList.vue?vue&type=script&lang=js"
export * from "./GiftPromotionList.vue?vue&type=script&lang=js"
import style0 from "./GiftPromotionList.vue?vue&type=style&index=0&id=9a0eb55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0eb55c",
  null
  
)

export default component.exports
import {QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton})
